Namespace 'Customer.Views.Insights'

class Customer.Views.Insights.ActivityColumnSelectorView extends Backbone.View
  template: JST['backbone/templates/customer/insights/activity_column_selector']
  events:
    'change #activity-type': 'resetSelectableColumns'
    'click .column-controls .select-all': 'selectAllColumns'
    'click .column-controls .clear-all': 'clearAllColumns'
    'click .subtype-selector-checkbox': 'resetSelectableColumns'

  initialize: (@options = {}) ->
    @columns = @options.columns
    @contentTypeExclusiveColumns = @options.content_type_exclusive_columns
    @columnsToDisplay = @columns[@_currentReportType()]

  render: ->
    @$('#column-filters').html @template
      columns: @columnsToDisplay

  resetSelectableColumns: ->
    exclude_columns = []
    $(".subtype-selector-checkbox").each (index, element) =>
      current_checkbox = $(element)
      current_subtype = current_checkbox.val()
      checked_value = current_checkbox.prop( "checked" )
      current_exlusive_cols = @exclude_metrics_by_subtype(current_subtype, checked_value)
      exclude_columns = exclude_columns.concat(current_exlusive_cols)
    @resetColumnsAndExclude(exclude_columns)

  resetColumnsAndExclude: (excluded_columns) ->
    @columnsToDisplay = _.filter(@columns[@_currentReportType()], (column) => return column not in excluded_columns );
    @render()

  exclude_metrics_by_subtype: (subtype,check_status) ->
    excluded_cols = []
    if !check_status
      excluded_cols = @contentTypeExclusiveColumns[subtype]
    excluded_cols

  _currentReportType: ->
    @$('#activity-type').find('input:checked').val()

  selectAllColumns: ->
    @_toggleAllColumns true

  clearAllColumns: ->
    @_toggleAllColumns false

  _toggleAllColumns: (state) ->
    @$('.available-column').find('input').prop('checked', state)
